import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _CentileDistribution;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import { PropTypes } from 'prop-types';
import { range } from 'd3-array';
import { jsx } from '@instructure/emotion';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { Table } from '@instructure/ui-table';
import Distribution from '../Distribution';
import t from '@instructure/quiz-i18n/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { withStyleOverrides } from '@instructure/quiz-common';
var starBin = function starBin(props) {
  if (typeof props.starScore !== 'number') return;
  var starScore = Math.max(0, Math.min(props.starScore, 1));
  // min+floor here matches quiz_etl HistogramHelper
  return Math.min(Math.floor(starScore * props.visualDistribution.length), props.visualDistribution.length - 1);
};
export var CentileDistribution = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_CentileDistribution = /*#__PURE__*/function (_Component) {
  function CentileDistribution() {
    var _this2;
    _classCallCheck(this, CentileDistribution);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, CentileDistribution, [].concat(args));
    _defineProperty(_this2, "_calculateAxis", function (x, y, xAxis, height) {
      x.domain(range(101));
      if (typeof _this2.props.starScore === 'number') {
        var starIndex = starBin(_this2.props);
        // Determine if star above bar will overflow height, and reduce range to
        // account for 18 star height + 12 star bottom padding
        var starTop = y(_this2.props.visualDistribution[starIndex]) - 30;
        y.rangeRound([height, _this2.props.barPaddingTop - Math.min(0, starTop)]);
      }
      xAxis.tickValues(range(0, 101, 10)).tickFormat(function (d) {
        return t('{percent, number}%', {
          percent: d
        });
      });
    });
    _defineProperty(_this2, "_createChart", function (svg, width) {
      // Manually redraw x axis to extend beyond container
      var axisPadding = 2000;
      svg.select('g[data-role=xAxis] path').attr('d', "M".concat(-1 * axisPadding, ",0H").concat(width + axisPadding));
      return svg;
    });
    _defineProperty(_this2, "_summarizeChart", function (summary) {
      if (typeof _this2.props.starScore !== 'number') return summary;
      return t('You scored {score, number, percent}. ', {
        score: _this2.props.starScore
      }) + summary;
    });
    _defineProperty(_this2, "_renderTable", function () {
      return jsx(ScreenReaderContent, null, jsx(Table, {
        caption: t('Score percentiles chart data')
      }, jsx(Table.Head, null, jsx(Table.Row, null, jsx(Table.ColHeader, {
        id: "score-percentiles-chart-data-score-percentile"
      }, t('Score Percentile')), jsx(Table.ColHeader, {
        id: "score-percentiles-chart-data-count"
      }, t('Count')))), jsx(Table.Body, null, _this2._renderTableRows())));
    });
    return _this2;
  }
  _inherits(CentileDistribution, _Component);
  return _createClass(CentileDistribution, [{
    key: "_renderTableRows",
    value: function _renderTableRows() {
      var chartData = this.props.visualDistribution;
      return chartData.map(function (count, index) {
        return jsx(Table.Row, {
          key: "".concat(index, ":").concat(count) /* eslint-disable-line react/no-array-index-key */
        }, jsx(Table.Cell, null, t('{percent}%', {
          percent: index
        })), jsx(Table.Cell, null, count));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var props = Object.assign({}, this.props, {
        calculateAxis: this._calculateAxis,
        createChart: this._createChart,
        renderTable: this._renderTable,
        summarizeChart: this._summarizeChart,
        starIndex: starBin(this.props)
      });
      return jsx("div", {
        className: "centileRoot",
        css: this.props.styles.centileRoot,
        "data-automation": "sdk-reporting-centile-root"
      }, jsx(Distribution, props));
    }
  }]);
}(Component), _defineProperty(_CentileDistribution, "displayName", 'CentileDistribution'), _defineProperty(_CentileDistribution, "componentId", "Quizzes".concat(_CentileDistribution.displayName)), _defineProperty(_CentileDistribution, "propTypes", {
  animateDelay: PropTypes.number,
  animateDuration: PropTypes.number,
  barPaddingInner: PropTypes.number,
  // Spacing between bars, so each is visible, could be accomplished by borders
  barPaddingOuter: PropTypes.number,
  // Spacing between bars, so each is visible, could be accomplished by borders
  barPaddingTop: PropTypes.number,
  chartHeight: PropTypes.number.isRequired,
  // Height in pixels
  chartWidth: PropTypes.number,
  /* *
   * * a fallback minimal distribution for tab-able, keyboard navigable buckets
   * * typically this will be ~ 10 buckets
   * */
  summaryDistribution: PropTypes.arrayOf(PropTypes.node),
  /* *
   * * A list of score values for each bucket.  Size of this array determines the number of buckets
   * */
  visualDistribution: PropTypes.arrayOf(PropTypes.node).isRequired,
  starScore: PropTypes.number,
  styles: PropTypes.object
}), _defineProperty(_CentileDistribution, "defaultProps", {
  animateDelay: 200,
  animateDuration: 900,
  barPaddingInner: 0.25,
  // Spacing between bars, so each is visible, could be accomplished by borders
  barPaddingOuter: 0,
  // Spacing between bars, so each is visible, could be accomplished by borders
  barPaddingTop: 0,
  // Spacing between highest bar and top of chart, pixels
  chartHeight: 200,
  // Height in pixels
  chartWidth: 900,
  summaryDistribution: void 0,
  visualDistribution: [],
  starScore: null
}), _CentileDistribution)) || _class);
export default CentileDistribution;